// src/utils/browserDetector.js
export class BrowserDetector {
    static Browser = {
        Safari: "Safari",
        Chrome: "Chrome",
        Firefox: "Firefox",
        Edge: "Edge",
        Unknown: "Unknown"
    }

    static Platform = {
        Ios: "Ios",
        Android: "Android",
        Desktop: "Desktop",
        Other: "Other",
    }

    static get(userAgent = navigator.userAgent) {
        const platform = this.getPlatform(userAgent)
        const browser = this.getBrowser(userAgent)
        return `${browser}.${platform}`
    }

    static getBrowser(userAgent = navigator.userAgent) {
        return this.detectBrowser(userAgent)
    }

    static getPlatform(userAgent = navigator.userAgent) {
        if (/Android/i.test(userAgent)) {
            return this.Platform.Android
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            return this.Platform.Ios
        } else {
            return this.Platform.Desktop
        }
    }
    static detectBrowser(userAgent) {
        if (/Safari/i.test(userAgent) && !/Chrome|CriOS|Edge|Edg/i.test(userAgent)) {
            return this.Browser.Safari
        } else if (/Chrome|CriOS/i.test(userAgent) && !/Edg/i.test(userAgent)) {
            return this.Browser.Chrome
        } else if (/Firefox/i.test(userAgent)) {
            return this.Browser.Firefox
        } else if (/Edg/i.test(userAgent)) {
            return this.Browser.Edge
        } else {
            return this.Browser.Unknown
        }
    }

    static is(browser, platform) {
        return this.get() === `${browser}.${platform}`
    }
}